// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__g6hLK","mainContent":"DashboardLayout_mainContent__HtDrp","content":"DashboardLayout_content__4zjqA"};